import { Extension } from '@tiptap/core';
import {
    ZyClassicLabInstructionNode,
    ZyClassicLabInstructionNodeHeadless,
    ZyClassicLabNode,
    ZyClassicLabNodeHeadless,
} from './zyclassiclab-extension';

export const ZyClassicLabHeadless = Extension.create({
    name: 'zyClassicLabWrapper',

    addExtensions() {
        return [ZyClassicLabInstructionNodeHeadless, ZyClassicLabNodeHeadless];
    },
});

export const ZyClassicLab = ZyClassicLabHeadless.extend({
    addExtensions() {
        return [ZyClassicLabInstructionNode, ZyClassicLabNode];
    },
});

export default ZyClassicLab;
